import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import { point, centroid, polygon } from "@turf/turf";


const useStyles = makeStyles((theme) => ({
    card: {
        marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));



export default function GeomNote({ geometry, disabled, handleChangeProperties }) {
    const classes = useStyles();
    const { t } = useTranslation();
    let center = null;
    
    if (geometry.coordinates[0][0]) {
        var geom = polygon(geometry.coordinates);
        center = centroid(geom).geometry.coordinates;
    } else 
        center = geometry.coordinates;

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-multiline-flexible"
                            label={t(`activity-name`)}
                            multiline
                            disabled={disabled}
                            maxRows={4}
                            fullWidth
                            name="activity"
                            value={geometry?.properties?.activity}
                            onChange={(e) => handleChangeProperties(e, geometry)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="filled-multiline-flexible"
                            label={t(`description`)}
                            multiline
                            disabled={disabled}
                            maxRows={4}
                            fullWidth
                            name="description"
                            value={geometry?.properties?.description}
                            onChange={(e) => handleChangeProperties(e, geometry)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography color="textSecondary" variant="caption"> 
                            {`${center[1]}`.substring(0, 10)}, {`${center[0]}`.substring(0, 10)} 
                        </Typography>
                    </Grid>
                </Grid>

            </CardContent>
        </Card>
    );
}